import { z } from 'zod';
import { FleetCommandVerbSchema, FleetLogStreamSchema } from '../admin/fleet-commands.schemas';

// The outbox payload for a just-issued command (IMM-910.5). Carries no `actor`
// envelope — `fleet.commands` is the queryable audit copy (with
// `requestedByAdminId` / `requestedAt`) and the relay channel is the durable
// record; this event exists to DELIVER the command to the outbox subscriber
// that signs and publishes it, not to record it a second time.
//
// `stream` / `lines` (IMM-910.6) travel here so the publish subscriber can
// build the relay envelope's log-verb fields; NEVER the presigned upload URL
// for `logs-download` — that is minted at publish time, straight onto the
// wire, and never stored (see `buildFleetCommandPublishSubscription`).
export const FleetCommandIssuedPayloadSchema = z.object({
  commandId: z.uuid(),
  machineId: z.uuid(),
  verb: FleetCommandVerbSchema,
  /** `null` for a host verb (`sync-branch`, `clean-checkout`) — it names no lane. */
  profile: z.string().nullable().default(null),
  stream: FleetLogStreamSchema.nullable().default(null),
  lines: z
    .union([z.literal(10), z.literal(50), z.literal(100)])
    .nullable()
    .default(null),
  issuedAt: z.iso.datetime(),
});

export type FleetCommandIssuedPayload = z.infer<typeof FleetCommandIssuedPayloadSchema>;
